import { rootActions, useAppDispatch, useAppSelector } from '../DAL/store';
import SearchIcon from "../../../ui/svg/common/search";
import {getFilteredItems} from "../services/logic-helper";
import {sendGAEvent} from "../../../domain/marketing/gtm-provider";

export const Filter = () => {

    const dispatch = useAppDispatch();
    const filterTerm = useAppSelector(store => store.filterTerm);
    const PageData = useAppSelector(store => store.PageData);
    const hideProductsOwn = useAppSelector(store => store.hideProductsOwn);
    const purchased = useAppSelector(store => store.purchased);
    /**
     * apply text filter
     */
    const applyFilter = (updatedFilterTerm: string) => {

        let filteredItems  = getFilteredItems(hideProductsOwn,purchased,PageData.freePlugins,updatedFilterTerm);
        dispatch(
            rootActions.main({
                filterTerm: updatedFilterTerm,
                filteredItems:filteredItems
            })
        );
    };

    return (
        <div className="flex items-center" style={{
            maxWidth: '183px',
        }}>
            <input
                className="text-sm font-normal text-gray-500 px-4 py-1 outline-none"
                aria-label={ "Search" }
                value={ filterTerm }
                autoComplete="off"
                type="text"
                placeholder={ "Search" }
                onInput={evt => {
                    const $el = evt.target as HTMLFormElement;
                    applyFilter($el.value);
                }}
                onClick={evt => {
                   sendGAEvent('JPList', 'Top Search');
                }}
                style={{
                    width: 'calc(100% - 13px)',
                }}
            />
            <SearchIcon width="13px" color="#252525" title="Filter" />
        </div>
    )
};